class StorageService {
  static localStorage = window.localStorage;

  static sessionStorage = window.sessionStorage;

  static getFromLocalStorage(key: string) {
    const getItem = this.localStorage.getItem(key);
    return getItem && JSON.parse(getItem);
  }

  static getFromSessionStorage(key: string) {
    const getItem = this.sessionStorage.getItem(key);
    return getItem && JSON.parse(getItem);
  }

  static setInLocalStorage(key: string, value: any) {
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  static setInSessionStorage(key: string, value: any) {
    this.sessionStorage.setItem(key, JSON.stringify(value));
  }

  static removeKeyFromSessionStorage(key: string) {
    if (this.getFromSessionStorage(key)) {
      this.sessionStorage.removeItem(key);
    }
  }

  static removeKeyFromLocalStorage(key: string) {
    if (this.getFromLocalStorage(key)) {
      this.localStorage.removeItem(key);
    }
  }
}

export default StorageService;
